import { SocialMessageStatsEnum, handleSocialProps } from './useWebsocketTypes';
import { updatePostStatsWs, updatePostWs } from 'redux/actions/feedActions';
import { idOnly } from 'utils/cls.utils';
import store from 'store';
import { updateCommentWs } from 'redux/actions/postActions';

const { dispatch } = store;

export function handleSocial({ fullMessage: { payload, type, rObject, rChild } }: handleSocialProps): void {
  try {
    if (type === SocialMessageStatsEnum.postStats) dispatch(updatePostStatsWs({ payload, rChild, rObject, type }));
    if (type === SocialMessageStatsEnum.postUpd)
      dispatch(
        updatePostWs({
          actionType: payload.c_status === '25:1' ? 'update' : 'delete',
          postId: idOnly(rObject),
        })
      );
    if (type === SocialMessageStatsEnum.commentStats && rChild && payload.reaction_count)
      dispatch(updateCommentWs({ commentId: idOnly(rChild), reaction_count: payload.reaction_count }));
  } catch (e) {
    console.error('websocket error: ', e);
  }
}
